module.exports = __webpack_public_path__ + "img/good-receipt.154e2c61.svg";